import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'buen-fin-BBB';
  isVisible: boolean = true;

  toggle() {
    this.isVisible = !this.isVisible;
  }

  onCompleted() {
    console.log("Emit onCompleted");
  }
}
